/**
 * 工厂 常量（MES 系统使用）
 */
import { COMPANY_ID } from './company.js';
export const FACTORY_CODE = {
    PSP: 'PSP',
    YPC: 'YPC',
};
export const DEFAULT_FACTORY_CODE = FACTORY_CODE.PSP;
/** 工厂代码 → APS 国家代码 映射 */
export const FACTORY_COUNTRY_MAP = {
    [FACTORY_CODE.PSP]: 'VN',
    [FACTORY_CODE.YPC]: 'KH',
};
/** 工厂代码 → 公司ID 映射 */
export const FACTORY_COMPANY_MAP = {
    [FACTORY_CODE.PSP]: COMPANY_ID.PSP,
    [FACTORY_CODE.YPC]: COMPANY_ID.YPC,
};
/** APS 国家代码默认值 (匹配 DEFAULT_FACTORY_CODE 的 country). */
export const DEFAULT_FACTORY_COUNTRY = FACTORY_COUNTRY_MAP[DEFAULT_FACTORY_CODE];
/**
 * 椭圆机默认产能 + 换型时间.
 * 用于 settings/machines 服务在创建产线时自动 attach Machine 行的兜底值,
 * 实际产能由 seed-machines.ts 按工厂分别覆盖。
 */
export const DEFAULT_OVAL_MACHINE_CAPACITY_MIN = 350;
export const DEFAULT_OVAL_MACHINE_CAPACITY_MAX = 600;
export const DEFAULT_OVAL_MACHINE_CHANGEOVER_MIN = 120;
/** 默认机台类型 (产线挂机时使用). */
export const DEFAULT_MACHINE_TYPE = 'oval';
/** 公司ID → 工厂代码 映射 (single-value: 一个公司归属一个工厂) */
export const COMPANY_FACTORY_MAP = {
    [COMPANY_ID.PSP]: FACTORY_CODE.PSP,
    [COMPANY_ID.YPC]: FACTORY_CODE.YPC,
};
/**
 * 公司 → 可访问工厂列表 (multi-value).
 * - WITTY (HQ): full access to PSP + YPC (consolidation, cross-factory reports).
 * - PSP / YPC: own factory only.
 *
 * 不同于 COMPANY_FACTORY_MAP (single-value, 用于 routing 默认归属)，
 * 这是用来做权限校验的多值访问表。
 */
export const COMPANY_FACTORY_ACCESS = {
    [COMPANY_ID.WITTY]: [FACTORY_CODE.PSP, FACTORY_CODE.YPC],
    [COMPANY_ID.PSP]: [FACTORY_CODE.PSP],
    [COMPANY_ID.YPC]: [FACTORY_CODE.YPC],
};
export const FACTORY_UI_CONFIG = {
    [FACTORY_CODE.PSP]: {
        nameKey: 'factory.psp_name',
        shortNameKey: 'factory.psp_short',
        flag: '\u{1F1FB}\u{1F1F3}',
        color: '#d4380d',
        displayName: 'PSP Vietnam',
    },
    [FACTORY_CODE.YPC]: {
        nameKey: 'factory.ypc_name',
        shortNameKey: 'factory.ypc_short',
        flag: '\u{1F1F0}\u{1F1ED}',
        color: '#531dab',
        displayName: 'YPC Cambodia',
    },
};
